export const trustPages = {
  "policy": {
    "title": {
      "en": "Policy",
      "es": "Política",
      "nl": "Beleid",
      "pap": "Politika"
    },
    "intro": {
      "en": "A short public statement on privacy and donations. TGWE keeps support voluntary, transparent, and separate from spiritual rank or authority.",
      "es": "Una declaración pública breve sobre privacidad y donaciones. TGWE mantiene el apoyo voluntario, transparente y separado de rango espiritual o autoridad.",
      "nl": "Een korte publieke verklaring over privacy en donaties. TGWE houdt steun vrijwillig, transparant en gescheiden van spirituele rang of gezag.",
      "pap": "Un deklarashon públiko kortiku tokante privasidat i donashon. TGWE ta tene sosten voluntario, transparente i separá for di rango spiritual òf outoridat."
    },
    "sections": [
      {
        "title": {
          "en": "Privacy",
          "es": "Privacidad",
          "nl": "Privacy",
          "pap": "Privasidat"
        },
        "paragraphs": [
          {
            "en": "TGWE collects only the information a visitor chooses to provide through public forms, donation processors, course platforms, email, or linked external services. Standard hosting, browser, and embedded-media records may be created by the services that deliver the site.",
            "es": "TGWE recopila solo la información que un visitante decide proporcionar mediante formularios públicos, procesadores de donación, plataformas de cursos, correo electrónico o servicios externos enlazados. Los servicios que entregan el sitio pueden crear registros estándar de alojamiento, navegador y medios incrustados.",
            "nl": "TGWE verzamelt alleen informatie die een bezoeker zelf verstrekt via publieke formulieren, donatieverwerkers, cursusplatforms, e-mail of gekoppelde externe diensten. Standaard hosting-, browser- en embedded-mediarecords kunnen worden aangemaakt door de diensten die de site leveren.",
            "pap": "TGWE ta kolektá solamente informashon ku un bishitante ta skohe duna via formulario públiko, procesadónan di donashon, plataforma di kurso, email òf servisionan eksterno ligá. Servisionan ku ta sirbi e site por krea rekordnan standard di hosting, browser i media inkrustá."
          },
          {
            "en": "TGWE does not sell personal information. Questions about public data, donation records, or course access can be sent through the current public contact channels.",
            "es": "TGWE no vende información personal. Las preguntas sobre datos públicos, registros de donación o acceso a cursos pueden enviarse por los canales públicos de contacto vigentes.",
            "nl": "TGWE verkoopt geen persoonlijke informatie. Vragen over publieke gegevens, donatierecords of cursustoegang kunnen via de actuele publieke contactkanalen worden gesteld.",
            "pap": "TGWE no ta bende informashon personal. Preguntanan tokante data públiko, rekordnan di donashon òf akseso na kurso por wordu manda via e kanalnan públiko aktual."
          }
        ]
      },
      {
        "title": {
          "en": "Donation policy",
          "es": "Política de donación",
          "nl": "Donatiebeleid",
          "pap": "Politika di donashon"
        },
        "paragraphs": [
          {
            "en": "Donations are voluntary support for the public Work. Support does not create rank, dependency, spiritual privilege, access control, or influence over the teaching.",
            "es": "Las donaciones son apoyo voluntario para la Obra pública. El apoyo no crea rango, dependencia, privilegio espiritual, control de acceso ni influencia sobre la enseñanza.",
            "nl": "Donaties zijn vrijwillige steun voor het publieke Werk. Steun creëert geen rang, afhankelijkheid, spiritueel privilege, toegangscontrole of invloed op het onderwijs.",
            "pap": "Donashonnan ta sosten voluntario pa e Obra públiko. Sosten no ta krea rango, dependensia, privilegio spiritual, kontròl di akseso òf influensia riba e siñansa."
          },
          {
            "en": "All donations are final and non-refundable. External payment processors may apply their own records, fees, confirmations, and security practices.",
            "es": "Todas las donaciones son finales y no reembolsables. Los procesadores externos de pago pueden aplicar sus propios registros, tarifas, confirmaciones y prácticas de seguridad.",
            "nl": "Alle donaties zijn definitief en niet restitueerbaar. Externe betaalverwerkers kunnen hun eigen records, kosten, bevestigingen en beveiligingspraktijken toepassen.",
            "pap": "Tur donashon ta final i no tin reembolso. Procesadónan eksterno di pago por apliká nan mes rekordnan, tarifanan, konfirmashonnan i práktikanan di seguridat."
          }
        ]
      }
    ]
  },
  "terms": {
    "title": {
      "en": "Terms",
      "es": "Términos",
      "nl": "Voorwaarden",
      "pap": "Terminonan"
    },
    "intro": {
      "en": "Terms for using the public TGWE website, materials, courses, media, and linked study paths.",
      "es": "Términos para usar el sitio público de TGWE, materiales, cursos, medios y rutas de estudio enlazadas.",
      "nl": "Voorwaarden voor het gebruik van de publieke TGWE-website, materialen, cursussen, media en gekoppelde studiepaden.",
      "pap": "Terminonan pa uza e website públiko di TGWE, materialnan, kursonan, media i kamindanan di estudio ligá."
    },
    "sections": [
      {
        "title": {
          "en": "Public study use",
          "es": "Uso de estudio público",
          "nl": "Publiek studiegebruik",
          "pap": "Uso públiko pa estudio"
        },
        "paragraphs": [
          {
            "en": "TGWE materials are offered for education, reflection, moral inquiry, and self-directed practice. They are not medical, legal, financial, or emergency advice.",
            "es": "Los materiales de TGWE se ofrecen para educación, reflexión, investigación moral y práctica autodirigida. No son consejo médico, legal, financiero ni de emergencia.",
            "nl": "TGWE-materialen worden aangeboden voor onderwijs, reflectie, moreel onderzoek en zelfgerichte oefening. Ze zijn geen medisch, juridisch, financieel of noodadvies.",
            "pap": "Materialnan di TGWE ta wordu ofresé pa edukashon, reflekshon, investigashon moral i práktika dirigí pa bo mes. Nan no ta konseho médiko, legal, finansiero òf di emergensia."
          },
          {
            "en": "Use the material with discernment, preserve authorship, and do not present TGWE content as your own authority structure. External links remain under the control of their own platforms.",
            "es": "Usa el material con discernimiento, conserva la autoría y no presentes el contenido de TGWE como tu propia estructura de autoridad. Los enlaces externos permanecen bajo el control de sus propias plataformas.",
            "nl": "Gebruik het materiaal met onderscheidingsvermogen, behoud auteurschap en presenteer TGWE-inhoud niet als je eigen gezagsstructuur. Externe links blijven onder controle van hun eigen platforms.",
            "pap": "Uza e material ku discernimentu, preservá outoria, i no presentá kontenido di TGWE komo bo mes struktura di outoridat. Linknan eksterno ta keda bou di kontròl di nan mes platformanan."
          }
        ]
      },
      {
        "title": {
          "en": "Study boundaries",
          "es": "Límites de estudio",
          "nl": "Studiegrenzen",
          "pap": "Fronteranan di estudio"
        },
        "paragraphs": [
          {
            "en": "The public site is an orientation threshold. The University remains a separate protected study space, and participation there is governed by its own access boundary.",
            "es": "El sitio público es un umbral de orientación. La Universidad sigue siendo un espacio de estudio protegido y separado, y la participación allí se rige por su propio límite de acceso.",
            "nl": "De publieke site is een oriëntatiedrempel. De Universiteit blijft een afzonderlijke beschermde studieruimte, en deelname daar valt onder haar eigen toegangsgrens.",
            "pap": "E site públiko ta un umbral di orientashon. Universidat ta keda un espasio protegí separá di estudio, i partisipashon aya ta sigui su mes frontera di akseso."
          },
          {
            "en": "No public page, donation, download, or course purchase gives spiritual rank, private authority, or guaranteed outcome.",
            "es": "Ninguna página pública, donación, descarga o compra de curso otorga rango espiritual, autoridad privada ni resultado garantizado.",
            "nl": "Geen publieke pagina, donatie, download of cursusaankoop geeft spirituele rang, private autoriteit of gegarandeerde uitkomst.",
            "pap": "Niun página públiko, donashon, download òf kompra di kurso ta duna rango spiritual, outoridat privá òf resultado garantisá."
          }
        ]
      }
    ]
  },
  "accreditation-statement": {
    "title": {
      "en": "Accreditation Statement",
      "es": "Declaración de Acreditación",
      "nl": "Accreditatieverklaring",
      "pap": "Deklarashon di Akreditashon"
    },
    "intro": {
      "en": "TGWE courses are independent initiatic education and guided practice spaces. They are public preparation for deeper work, not government or university accreditation.",
      "es": "Los cursos de TGWE son educación iniciática independiente y espacios guiados de práctica. Son preparación pública para un trabajo más profundo, no acreditación gubernamental ni universitaria.",
      "nl": "TGWE-cursussen zijn onafhankelijke initiatische educatie en begeleide oefenruimtes. Ze zijn publieke voorbereiding op dieper werk, geen overheids- of universitaire accreditatie.",
      "pap": "Kursonan di TGWE ta edukashon inisiátiko independiente i espasionan guia di práktika. Nan ta preparashon públiko pa trabou mas profundo, no akreditashon di gobièrnu òf universidat."
    },
    "sections": [
      {
        "title": {
          "en": "Independent education",
          "es": "Educación independiente",
          "nl": "Onafhankelijk onderwijs",
          "pap": "Edukashon independiente"
        },
        "paragraphs": [
          {
            "en": "Unless stated in a specific course contract, TGWE courses are not accredited by a government agency, college, university, or licensing board.",
            "es": "Salvo que se indique en un contrato específico de curso, los cursos de TGWE no están acreditados por una agencia gubernamental, colegio, universidad ni junta de licencias.",
            "nl": "Tenzij dit in een specifiek cursuscontract staat, zijn TGWE-cursussen niet geaccrediteerd door een overheidsinstantie, hogeschool, universiteit of beroepslicentie-instantie.",
            "pap": "A ménos ku un kontrato spesífiko di kurso bisa otro, kursonan di TGWE no ta akreditá pa un agensia di gobièrnu, kolegio, universidat òf junta di lisensia."
          },
          {
            "en": "Course completion alone does not certify professional, therapeutic, legal, medical, or licensed competence. Any TGWE recognition must be tied to demonstrated understanding, moral conduct, and practical capacity.",
            "es": "Completar un curso por sí solo no certifica competencia profesional, terapéutica, legal, médica ni licenciada. Todo reconocimiento de TGWE debe estar ligado a comprensión demostrada, conducta moral y capacidad práctica.",
            "nl": "Het afronden van een cursus op zichzelf certificeert geen professionele, therapeutische, juridische, medische of gelicentieerde bekwaamheid. Elke TGWE-erkenning moet verbonden zijn aan aangetoond begrip, moreel gedrag en praktische capaciteit.",
            "pap": "Terminá un kurso so no ta sertifiká kompetensia profesional, terapéutiko, legal, médiko òf lisensiá. Kualke rekonosementu di TGWE mester ta ligá na komprondementu demonstrá, kondukta moral i kapasidat práktiko."
          }
        ]
      },
      {
        "title": {
          "en": "Student responsibility",
          "es": "Responsabilidad del estudiante",
          "nl": "Studentverantwoordelijkheid",
          "pap": "Responsabilidat di studiante"
        },
        "paragraphs": [
          {
            "en": "Students remain responsible for discernment, application, and alignment with Natural Law, professional agreements, and personal limits.",
            "es": "Los estudiantes siguen siendo responsables del discernimiento, la aplicación y la alineación con la Ley Natural, los acuerdos profesionales y los límites personales.",
            "nl": "Studenten blijven verantwoordelijk voor onderscheidingsvermogen, toepassing en afstemming op Natuurwet, professionele afspraken en persoonlijke grenzen.",
            "pap": "Studiantenan ta keda responsabel pa discernimentu, aplikashon i alineashon ku Lei Natural, akuerdonan profesional i límite personal."
          }
        ]
      }
    ]
  },
  "code-of-moral-conduct": {
    "title": {
      "en": "Code of Moral Conduct",
      "es": "Código de Conducta Moral",
      "nl": "Code van Moreel Gedrag",
      "pap": "Kódigo di Kondukta Moral"
    },
    "intro": {
      "en": "The moral covenant of TGWE: truth before image, freedom before dependency, and service before control.",
      "es": "El pacto moral de TGWE: verdad antes que imagen, libertad antes que dependencia y servicio antes que control.",
      "nl": "Het morele verbond van TGWE: waarheid vóór beeld, vrijheid vóór afhankelijkheid en dienstbaarheid vóór controle.",
      "pap": "E paktu moral di TGWE: bèrdat promé ku imágen, libertat promé ku dependensia, i servisio promé ku kontròl."
    },
    "sections": [
      {
        "title": {
          "en": "Teacher and student",
          "es": "Maestro y estudiante",
          "nl": "Leraar en student",
          "pap": "Maestro i studiante"
        },
        "paragraphs": [
          {
            "en": "The teacher may guide, clarify, and witness, but must not own the student's perception. The aim is independence through right relationship with truth.",
            "es": "El maestro puede guiar, aclarar y dar testimonio, pero no debe poseer la percepción del estudiante. El objetivo es independencia mediante una relación correcta con la verdad.",
            "nl": "De leraar mag begeleiden, verhelderen en getuigen, maar mag de waarneming van de student niet bezitten. Het doel is onafhankelijkheid door juiste verhouding tot waarheid.",
            "pap": "E maestro por guia, klariá i ta testigu, pero no mester poseé persepshon di e studiante. E meta ta independensia pa medio di relashon korekto ku bèrdat."
          },
          {
            "en": "Uncertainty must be named. Historical claims, philosophical arguments, esoteric readings, and personal interpretations must not be confused with one another.",
            "es": "La incertidumbre debe nombrarse. Las afirmaciones históricas, argumentos filosóficos, lecturas esotéricas e interpretaciones personales no deben confundirse entre sí.",
            "nl": "Onzekerheid moet benoemd worden. Historische claims, filosofische argumenten, esoterische lezingen en persoonlijke interpretaties mogen niet met elkaar worden verward.",
            "pap": "Inkertidumbre mester wordu nombra. Afirmashonnan históriko, argumentonan filosófiko, lesaduranan esotériko i interpretashonnan personal no mester wordu konfundi ku otro."
          }
        ]
      },
      {
        "title": {
          "en": "Ma'at in public work",
          "es": "Ma'at en la obra pública",
          "nl": "Ma'at in publiek werk",
          "pap": "Ma'at den trabou públiko"
        },
        "paragraphs": [
          {
            "en": "Public work must not use coercion, dependency, fear, false scarcity, spiritual rank, or psychological vulnerability as tools of control.",
            "es": "La obra pública no debe usar coerción, dependencia, miedo, escasez falsa, rango espiritual ni vulnerabilidad psicológica como herramientas de control.",
            "nl": "Publiek werk mag geen dwang, afhankelijkheid, angst, valse schaarste, spirituele rang of psychologische kwetsbaarheid gebruiken als controle-instrument.",
            "pap": "Trabou públiko no mester uza koakshon, dependensia, miedo, eskases falsu, rango spiritual òf vulnerabilidat psikológiko komo hèrment di kontròl."
          },
          {
            "en": "Speech is Heka: it must serve clarity, right action, and liberation. If a practice creates confusion, dependency, or exploitation, it must be corrected or removed.",
            "es": "La palabra es Heka: debe servir a la claridad, la acción correcta y la liberación. Si una práctica crea confusión, dependencia o explotación, debe corregirse o eliminarse.",
            "nl": "Spraak is Heka: zij moet helderheid, juist handelen en bevrijding dienen. Als een praktijk verwarring, afhankelijkheid of uitbuiting creëert, moet zij worden gecorrigeerd of verwijderd.",
            "pap": "Palabra ta Heka: e mester sirbi klaridat, akshon korekto i liberashon. Si un práktika ta krea konfushon, dependensia òf eksplotashon, e mester wordu koregí òf eliminá."
          }
        ]
      }
    ]
  }
};
